<template>
    <div>
        <e-dialog
                dialog-title="发票冲红"
                :center-dialog-visible="invoiceOffsetRedVisible"
                popup-width="400px"
                buttonTip="继续冲红"
                :closeBtn="true"
                @resetPopupData="handleClose"
                @submitPopupData="submitPopupData">
            <!--电子普票-->
            <div v-if="invoiceType === 1">
                您正在冲红一张发票，如需重新开具，请返回“待开票清单”中对此订单重新开票。
            </div>
            <div v-else>
                <div>您正在冲红一张增值税专用发票，目前增值税专用发票仅支持人工冲红，冲红周期较长，一旦申请无法撤回。</div>
                <div class="margin-t10">必须完成冲红后，才可重新申请开票。</div>
            </div>
            <div class="margin-t10">是否继续冲红？</div>
        </e-dialog>
    </div>
</template>

<script>
import eDialog from '../../../components/common/e-dialog';
import api from '@/modules/projectA/api/pay';
export default {
  components:{
    eDialog
  },
  props:{
    invoiceId:Number,
    invoiceOffsetRedVisible:Boolean,
    invoiceType:Number,
  },
  data(){
    return{

    }
  },
  methods:{
    async submitPopupData(){
      const res = await api.paymentInvoiceVoiding({invoiceId:this.invoiceId});
      if (res.success) {
        this.$message.success('操作成功');
        this.handleClose();
        this.$parent.queryPaymentInvoicePage();
      }
    },
    handleClose(){
      this.$emit('update:invoiceOffsetRedVisible', false);
    },
  },

}
</script>

<style scoped>

</style>